import axios, { AxiosInstance } from 'axios';
import Cookies from 'js-cookie';

const instance: AxiosInstance = axios.create({
  baseURL: import.meta.env.DEV
    ? import.meta.env.VITE_APP_BACKEND_URL
    : `${import.meta.env.VITE_APP_BACKEND_URL}/api/v1`,
  headers: { Accept: 'application/json' },
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  if (config.method === 'post' || config.method === 'patch' || config.method === 'delete') {
    config.headers['X-CSRF-Token'] = Cookies.get('csrf_token');
  }
  return config;
});

export default instance;
